
import Env from '../base/env.js';
import Channels from '../base/channels.js';
import lozad from 'lozad'
import Launcher from '../view/launcher'
import MainnavTouch from '../ui/MainnavTouch'
import Subnav from '../ui/Subnav'
import UISwitcher from '../ui/UISwitcher'
import FakeScroll from '../modules/FakeScroll'
import LangSelector from '../components/LangSelector'

class UI
{
    constructor()
    {
      if(typeof history.scrollRestoration != 'undefined') {
          history.scrollRestoration = 'manual';
      }
      // this.uiSwitch =  new UISwitcher()
      Env.framework.mainnav = new MainnavTouch()
      Env.framework.subnav = new Subnav()
      this.langSelector = new LangSelector()
      this.launcher = new Launcher()
      this.fs = new FakeScroll()
      this.fs.setup()
      this.ageGate()
      this.detectAppHeight()
      this.detectLangHeight()
      this.resetEnv();
      this.cacheHomeVideos()


    }

    ageGate()
    {
      const getStr = trans.dateTxt
      const today = new Date()
      const getDay = today.getDate() + 1;
      const getMonth = today.getMonth();
      const getYear = today.getFullYear() - 18;
      const geneDate = new Date(Date.UTC(getYear, getMonth, getDay, 0, 0, 0));
      const options = { year: 'numeric', month: 'long', day: 'numeric' };
      const newStr = getStr.replace('[date]',geneDate.toLocaleDateString(config.localeRegion, options))
      if(document.querySelector('.jsAgeGate--date') != null) {
        this.lazy()
        document.querySelector('.jsAgeGate--date').innerHTML = newStr
        Env.$body.classList.add('tw-overflow-hidden')
      }
      this.lazyNav()
    }

    appHeight()
    {
      const doc = document.documentElement
      doc.style.setProperty('--app-height', `${window.innerHeight}px`)
    }

    cacheHomeVideos()
    {

      const getCurrentController = Env.framework.toolbox.getController()
      const urlDesktop = 'https://player.vimeo.com/progressive_redirect/playback/771513268/rendition/1080p/file.mp4?loc=external&signature=748d48fd1ad861ad76c182247258327e689d683c33cc1103db6ac0bb98313011'
      const urlMobile = 'https://player.vimeo.com/progressive_redirect/playback/773277696/rendition/540p/file.mp4?loc=external&signature=c3803a96ab25bfb4a8cc45d43f45fbbeb2db5e948f8132375385d6360b993ea9'
      if(getCurrentController != 'home') {
        var video = document.createElement('video')
        if(Env.mobileCSS == true) {
          video.src = urlMobile
        } else {
          video.src = urlDesktop
        }
      }
    }

    detectAppHeight()
    {
      this.appHeight()
      Channels.on('window::smartresize',this.appHeight)
    }

    detectLangHeight()
    {
      const doc = document.documentElement
      const $lang = document.querySelector('.jsLangSelector--view')
      const coords = $lang.getBoundingClientRect()
      const setTranslateY = (coords.height - 19) * -1
      doc.style.setProperty('--app-lang-height', `${coords.height}px`)
      doc.style.setProperty('--app-lang-translate-y', `${setTranslateY}px`)
      $lang.classList.add('is--ready')
      // Mobile
      const $langMobile = document.querySelector('.jsLangMobile--view')
      const coordsMobile = $langMobile.getBoundingClientRect()
      doc.style.setProperty('--app-lang-height-mobile', `${coordsMobile.height}px`)
      $langMobile.classList.add('is--ready')
      $langMobile.addEventListener('click',()=>{
        $langMobile.classList.toggle('opened')
      })
    }


    lazy()
    {
      const observer = lozad(); // lazy loads elements with default selector as '.lozad'
      observer.observe();
    }

    lazyNav()
    {
      const el = document.querySelector('.jsLozadNav');
      const observer = lozad(el);
      observer.observe();
    }

    resetEnv()
    {
      Channels.on('statechange::before',function()
      {

      })
      Channels.on('statechange::ready',(current,old,container)=>
      {
          // Env.$html.classList.remove('skin--isWhite')
          // Env.$html.classList.remove('skin--isDark')
          // Env.$mainNav.classList.remove('is--active');
          // Env.$html.classList.remove('mainnav--isOpened')
          Env.$html.classList.remove('subnav-isOpened')
          this.langSelector.update()
        })
    }
}

export default UI;
